import Vue from 'vue'
import Vuex from 'vuex'

import sessao from './modules/sessao'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { sessao}
})